// Food allowance is a Head Office benefit only. Mirrors the backend rule
// food_allowance_applies() in hr-backend candidates/models.py — keep them in sync.
// "HO" is the payroll TEAM-HEAD group (one of the Vinod / Sathish / HO / MDH
// salary files), not the branch name.
export const FOOD_ALLOWANCE_TEAM_HEAD = 'HO';

// Team head only. Branch name is NOT consulted: the HO office also seats
// Vinod/MDH staff, so someone with no team head gets nothing rather than being
// guessed from where they sit (QA #48342). Matches food_allowance_applies().
export const isFoodAllowanceApplicable = (employee) => {
  if (!employee) return false;
  const teamHead = String(employee.team_head ?? employee.file ?? '').trim().toUpperCase();
  return teamHead === FOOD_ALLOWANCE_TEAM_HEAD;
};
